import React from 'react';
import { MessageCircle, Video, Users, Shield, Globe } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export const LandingScreen = ({ onSelectChatType }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4">
            Talk to Strangers
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8">
            Connect with people from around the world instantly
          </p>
          
          {/* Features */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <div className="flex items-center gap-2 bg-white/60 px-4 py-2 rounded-full">
              <Users className="w-5 h-5 text-blue-600" />
              <span className="text-sm font-medium">Anonymous</span>
            </div>
            <div className="flex items-center gap-2 bg-white/60 px-4 py-2 rounded-full">
              <Shield className="w-5 h-5 text-green-600" />
              <span className="text-sm font-medium">Safe</span>
            </div>
            <div className="flex items-center gap-2 bg-white/60 px-4 py-2 rounded-full">
              <Globe className="w-5 h-5 text-purple-600" />
              <span className="text-sm font-medium">Global</span>
            </div>
          </div>
        </div>

        {/* Chat Options */}
        <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          {/* Text Chat */}
          <Card className="cursor-pointer hover:shadow-lg transition-shadow duration-200 bg-white/80 backdrop-blur-sm border-2 hover:border-blue-300">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 p-4 bg-blue-100 rounded-full w-fit">
                <MessageCircle className="w-12 h-12 text-blue-600" />
              </div>
              <CardTitle className="text-2xl font-bold text-gray-900">
                Text Chat
              </CardTitle>
              <CardDescription className="text-gray-600">
                Start a conversation with text messages
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center">
              <ul className="text-sm text-gray-600 mb-6 space-y-2">
                <li>• Anonymous messaging</li>
                <li>• Instant connection</li>
                <li>• Skip to next person anytime</li>
                <li>• No registration required</li>
              </ul>
              <Button 
                onClick={() => onSelectChatType('text')}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                size="lg"
              >
                Start Text Chat
              </Button>
            </CardContent>
          </Card>

          {/* Video Chat */}
          <Card className="cursor-pointer hover:shadow-lg transition-shadow duration-200 bg-white/80 backdrop-blur-sm border-2 hover:border-purple-300">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 p-4 bg-purple-100 rounded-full w-fit">
                <Video className="w-12 h-12 text-purple-600" />
              </div>
              <CardTitle className="text-2xl font-bold text-gray-900">
                Video Chat
              </CardTitle>
              <CardDescription className="text-gray-600">
                Face-to-face conversations with strangers
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center">
              <ul className="text-sm text-gray-600 mb-6 space-y-2">
                <li>• Real-time video & audio</li>
                <li>• HD quality calls</li>
                <li>• Camera & mic controls</li>
                <li>• Secure P2P connection</li>
              </ul>
              <Button 
                onClick={() => onSelectChatType('video')}
                className="w-full bg-purple-600 hover:bg-purple-700 text-white"
                size="lg"
              >
                Start Video Chat
              </Button>
            </CardContent>
          </Card>
        </div>

        {/* Footer */}
        <div className="text-center mt-12 text-gray-500">
          <p className="text-sm">
            By using this service, you agree to be respectful and follow community guidelines
          </p>
        </div>
      </div>
    </div>
  );
}; 